<template>
  <span>
    <buttonEdit :ref="`btnEdit_${clave}`" :clave="clave" :clase="clsEdtCom" :clavestr="clavestr" :showedit="showedit" :loading="loading" @edit="edit" />
    <buttonDisable :ref="`btnDis_${clave}`" :clave="clave" :clase="clsDisCom" :clavestr="clavestr" :showdisable="showdisable" :isdelete="isdelete" :loading="loading" @disable="disable" />
    <buttonAudit :ref="`btnAudit_${clave}`" :clave="clave" :clase="clsAudCom" :clavestr="clavestr" :descripcion="descripcion" :showaudit="showaudit" :loading="loading" @audit="audit" />
  </span>
</template>
<script>
import ButtonEdit from "@/components/datatable/ButtonEdit"; /** *******************************/
import ButtonDisable from "@/components/datatable/ButtonDisable"; /** *******************************/
import ButtonAudit from "@/components/datatable/ButtonAudit"; /** *******************************/

export default {
  name: "ButtonsComons"
  , components: { ButtonEdit, ButtonDisable, ButtonAudit }
  , props: {
    clave: {
      default: null
      , type: Number
    }
    , clavestr: {
      default: null
      , type: String
    }
    , descripcion: {
      default: ""
      , type: String
    }
    , showedit: {
      default: true
      , type: Boolean
    }
    , showdisable: {
      default: false
      , type: Boolean
    }
    , showaudit: {
      default: true
      , type: Boolean
    }
    , isdelete: {
      default: false
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: ""
      , type: String
    }
    , claseedit: {
      default: ""
      , type: String
    }
    , clasedisable: {
      default: ""
      , type: String
    }
    , claseaudit: {
      default: ""
      , type: String
    }
  }
  , computed: {
    clsEdtCom() {
      return this.clase ? this.clase + this.claseedit : this.claseedit;
    }
    , clsDisCom() {
      return this.clase ? this.clase + this.clasedisable : this.clasedisable;
    }
    , clsAudCom() {
      return this.clase ? this.clase + this.claseaudit : this.claseaudit;
    }
  }
  , methods: {
    edit(clave) {
      this.$emit("edit", clave);
    }
    , disable(clave) {
      this.$emit("disable", clave);
    }
    , audit(clave, descripcion) {
      this.$emit("audit", clave, descripcion);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/Buttons.vue